export const questions = `
1. Walk me through a basic LBO model.
2. Why would you use leverage when buying a company
3. What variables impact an LBO model the most?
4. How do you pick purchase multiples and exit multiples in an LBO model?
5. What is an "ideal" candidate for an LBO?
6. How do you use an LBO model to value a company, and why do we sometimes say that it sets the "floor valuation" for the company?
7. Give an example of a "real‐life" LBO.
8. Can you explain how the Balance Sheet is adjusted in an LBO model?
9. Why are Goodwill & Other Intangibles created in an LBO?
10. We saw that a strategic acquirer will usually prefer to pay for another company in cash – if that's the case, why would a PE firm want to use debt in an LBO?
11. Do you need to project all 3 statements in an LBO model? Are there any "shortcuts?"
12. How would you determine how much debt can be raised in an LBO and how many tranches there would be?
13. Let's say we're analyzing how much debt a company can take on, and what the terms of the debt should be. What are reasonable leverage and coverage ratios?
14. What is the difference between bank debt and high‐yield debt?
15. Why might you use bank debt rather than high‐yield debt in an LBO?
16. Why would a PE firm prefer high‐yield debt instead?
17. Why would a private equity firm buy a company in a "risky" industry, such as technology?
18. How could a private equity firm boost its return in an LBO?
19. What is meant by the "tax shield" in an LBO?
20. What is a dividend recapitalization ("dividend recap")?
21. Why would a PE firm choose to do a dividend recap of one of its portfolio companies?
22. How would a dividend recap impact the 3 financial statements in an LBO?
`;